<template>
  <div class="edit-episode-audio">
    <transition name="app-fade" mode="out-in">
      <router-view
        :key="$route.fullPath"
        class="shows-route-episodes-route-container-wizard-two-block"
        keep-alive
      >
      </router-view>
    </transition>

    <confirm-modal-v3
      :contentText="confirmModal.contentText"
      :headerText="confirmModal.headerText"
      @close="onConfirmModalClose"
      @confirm="onConfirmModalConfirm"
      v-if="confirmModal.isOpen"
    />
  </div>
</template>

<script>
import ConfirmModalV3 from '@/components/ConfirmationModal.vue';
import { uploadAudioMixin } from '@/mixins/uploadAudioMixin';

export default {
  name: 'EditEpisodeRoute',

  mixins: [uploadAudioMixin],

  components: {
    ConfirmModalV3,
  },

  data() {
    return {
      confirmModal: {
        abandonUpload: false,
        contentText: 'Navigating away from this page will abandon the upload in progress. Please confirm that you wish to leave.',
        headerText: 'Upload still in progress',
        isOpen: false,
        toRoute: null,
      },
    };
  },

  computed: {
    step () {
      switch (this.$route.name) {
        case 'edit-episode-information':
          return 2;
        case 'edit-episode-publish':
          return 3;
        default:
          return 1;
      }
    },

    canLeaveRoute() {
      if (this.isUploading) {
        return this.confirmModal.abandonUpload;
      }
      return true;
    },
  },

  methods: {
    setStep () {
      this.$store.dispatch('draftEpisodes/setStep', this.step);
    },

    onConfirmModalClose() {
      this.confirmModal.isOpen = false;
      this.confirmModal.toRoute = null;
    },

    onConfirmModalConfirm() {
      this.confirmModal.abandonUpload = true;
      this.$router.push(this.confirmModal.toRoute);
    },

    openConfirmModal(toRoute) {
      this.confirmModal.isOpen = true;
      this.confirmModal.toRoute = toRoute;
    },

    resetConfirmModal() {
      this.confirmModal.isOpen = false;
      this.confirmModal.toRoute = null;
      this.confirmModal.abandonUpload = false;
    }
  },

  created () {
    this.setStep();
  },

  watch: {
    '$route': 'setStep'
  },

  beforeRouteLeave (to, _from, next) {
    if (this.canLeaveRoute) {
      this.$store.commit('draftEpisodes/SET_EDITING_EPISODE_DATA', { episode: null });
      next();
      this.resetConfirmModal();
    } else {
      this.openConfirmModal(to);
    }
  },

  beforeRouteUpdate(to, _from, next) {
    if (this.canLeaveRoute) {
      next();
      this.resetConfirmModal();
    } else {
      this.openConfirmModal(to);
    }
  },
};
</script>

<style lang="scss">
  .edit-episode-audio {

    .edit-episode-progress {
      margin: 20px auto;
    }
  }
</style>
